import type { CSSProperties, ReactNode, MouseEventHandler } from 'react';

export interface TableCellProps {
  children?: ReactNode;
  className?: string;
  header?: boolean;
  onClick?: MouseEventHandler<HTMLTableCellElement>;
  // For a per-column min-width driven by a runtime value (not a static Tailwind
  // class) — Tailwind's JIT scanner can't extract arbitrary-value classes built
  // via template-literal interpolation (e.g. `min-w-[${x}px]`), so that never
  // generates real CSS. Use this instead for any width that comes from a variable.
  style?: CSSProperties;
}

export const TableCell = ({ children, className = '', header = false, onClick, style, ...rest }: TableCellProps) => {
  const Tag = header ? 'th' : 'td';
  const base = header
    ? 'sticky top-0 bg-[#edf4f5] text-left px-5 py-3 text-[13px] font-medium text-gray-600'
    : 'px-5 py-3.5 text-gray-700';
  return (
    <Tag className={`${base} ${className}`} onClick={onClick} style={style} {...rest}>
      {children}
    </Tag>
  );
};
